import { render } from "./MyButton.vue?vue&type=template&id=46ee17f1&scoped=true"
import script from "./MyButton.vue?vue&type=script&lang=js"
export * from "./MyButton.vue?vue&type=script&lang=js"

import "./MyButton.vue?vue&type=style&index=0&id=46ee17f1&scoped=true&lang=css"

import exportComponent from "D:\\secret\\py\\main_bot\\bank-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ee17f1"]])

export default __exports__